import { Component, Input } from '@angular/core';
import { DateTimeFormat, AvatarSize, IconName, BadgeSize, BadgeType, DateUtils } from '@yupma/ui-kit';
import { ActivityDefinitionDocument, ActivityDocument, DefaultEntityFields, UserDocument } from 'server-model';
import { CRMActivityDataService, IAMService } from 'src/app/services/services.module';

@Component({
  selector: 'app-tasks-list-item',
  templateUrl: './tasks-list-item.component.html',
  styleUrl: './tasks-list-item.component.scss'
})
export class TasksListItemComponent {
  @Input() activity: ActivityDocument | null = null;
  @Input() definition: ActivityDefinitionDocument | null = null;
  @Input() allUsers: UserDocument[] = [];
  dateTimeFormats = DateTimeFormat;
  avatarSizes = AvatarSize;
  iconNames = IconName;
  badgeSizes = BadgeSize;
  badgeTypes = BadgeType;
  currentTimestamp = DateUtils.getCurrentTimeStamp();
  assignedToUser: UserDocument | null = null;

  constructor(
    private crmActivityDataService: CRMActivityDataService,
    private iamService: IAMService,
  ) { }

  ngOnInit(): void {
    this.initializeAssignedUser();
  }

  private initializeAssignedUser() {
    if (this.activity && this.activity['assigned_to']) {
      this.assignedToUser = this.allUsers.find(user => user.id === this.activity!['assigned_to']) || null;
    }
  }

  updateActivityCompleteStatus(status: boolean): void {
    if (!this.activity) return;

    this.activity['is_completed'] = status;
    const uid = this.iamService.getUserId();
    const currentTimeStamp = DateUtils.getCurrentTimeStamp();

    this.crmActivityDataService.updateActivity(
      this.activity.id,
      this.activity.org_id,
      { is_completed: status, [DefaultEntityFields.UPDATED_ON]: currentTimeStamp, [DefaultEntityFields.UPDATED_BY]: uid }
    );
  }
}
